import {MobCard} from "../components/MobCard";
import {DynamicIcon} from "lucide-react/dynamic";
import React, {Fragment, useRef, useState,useEffect} from "react";
import {contactCopie, contactFormatTel, getContactAdresses, getContactEmails, getContactTels} from "./functions";
import { Popover } from 'antd-mobile'
import {Trans} from "@lingui/react/macro";
import {t} from "@lingui/core/macro";
import {useNavigate} from "react-router-shim";
import {MOBCOLORS, MOBILE_PREFIX_PATH} from "../../configs/AppConfig";
import {useActionSheet} from "../providers/ActionSheetProvider";
import {HDate} from "@hebcal/core";
import Hebcal from "../../hebcal";
import moment from "moment";
import ModalAnniv from "../../views/app-views/contact/ModalAnniv";
import ApiService from "../../services/ApiService";
import ModalEditTels from "./ModalEditTels";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import ModalEditEmails from "./ModalEditEmails";
import ModalEditAdresses from "./ModalEditAdresses";
import MobPressable from "../components/MobPressable";
import MobContactIcon from "../components/MobContactIcon";

export default function ContactTabMain({selected}){

    return(
        <div style={{display:"flex",flexDirection:"column",gap:15}}>
            <CardParents selected={selected}/>
            <CardDeceased selected={selected}/>
            <CardTels selected={selected}/>
            <CardEmails selected={selected}/>
            <CardAdresses selected={selected}/>
            {selected.__allowEdit &&(
                <CardDDN selected={selected}/>
            )}
            <CardNote selected={selected}/>
        </div>
    )
}

function CardParents({selected}) {
    const parents=selected?.parents || []

    const navigate=useNavigate();

    if(parents.length===0){
        return null
    }

    return(
        <>
            <MobCard style={{boxShadow:"none",position:"relative"}}>
                <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>

                <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:"400"}}><Trans>Parents</Trans></span>

                {parents.map((item,index)=>{
                    return(
                        <div key={item.id}>
                            {index>0 &&(
                                <Divider/>
                            )}
                            <div style={{display:"flex",flexDirection:"column",padding:"8px 0px"}}>

                                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>

                                    <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:5}}>
                                        <span style={{color:MOBCOLORS.blue.color,fontSize:18,textDecorationLine:"underline"}} onClick={()=>navigate(MOBILE_PREFIX_PATH+"/contacts/fiche/?id="+item.id)}><span style={{textTransform:"capitalize"}}>{item.prenom}</span> <span style={{textTransform:"uppercase",fontWeight:"bold"}}>{item.nom}</span></span>
                                         <MobContactIcon contact={item} reversed/>
                                    </div>

                                </div>
                            </div>
                        </div>

                    )
                })}
                </div>
            </MobCard>

        </>
    )
}


function CardDeceased({selected}) {

    const getHebddn=(ddn,getHDate=false)=>{
        let org = null
        try {
            org = JSON.parse(localStorage.getItem("ORG"))
        } catch (e) {
        }

        var hdate = new HDate(new Date(ddn))
        if (org) {
            const hebcal = new Hebcal(org, new Date(), org.lat, org.long)
            hdate = hebcal.getAnnivHDate(new Date(ddn))
        }
        if(getHDate){
            return hdate
        }
        return hdate.getDate() + " " + hdate.getMonthName() + " " + hdate.getFullYear()
    }

    if(!selected.deceased){
        return null
    }

    const data=[
        {text:t`Date du décés`,value:selected.deceasedDate,format:moment(selected.deceasedDate).format("DD/MM/YYYY") + " - " + getHebddn(selected.deceasedDate)},
        {text:t`Prénom hébraique`,value:selected.prenomHE},
        {text:t`Prénom du Pere`,value:selected.deceasedPere},
        {text:t`Prénom de la Mere`,value:selected.deceasedMere},
        {text:t`Lieu de l'enterrement`,value:selected.deceasedLocation},
    ]

    return(
        <>
            <MobCard style={{boxShadow:"none",position:"relative"}}>
                    {data.filter(i=>i.value).map((item,index)=>{
                        return(
                            <div key={item.id}>
                                {index>0 &&(
                                    <Divider/>
                                )}
                                <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>
                                    <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:item.main?"bold":"400"}}>{item.text}</span>

                                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                        <span style={{color:MOBCOLORS.blue.color,fontSize:15}}>{item.format || item.value}</span>

                                        <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10}}>

                                            <Popover
                                                content={(<Trans>{item.text} Copié</Trans>)}
                                                trigger='click'
                                                placement='top'
                                                mode='dark'
                                            >
                                                <div style={{display: "flex", alignItems: "center", gap: 5}}
                                                     onClick={() => {contactCopie(item.format || item.value)}}>
                                                    <DynamicIcon name={"copy"} color={"#000"} size={24} style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                                                </div>
                                            </Popover>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        )
                    })}
            </MobCard>

        </>
    )
}

function CardTels({selected}) {
    const tels=getContactTels(selected)
    const modalEditTels=useRef(null);

    if(tels.length===0 || selected?.parents?.length>0){
        return null
    }

    return(
        <>
        <MobCard style={{boxShadow:"none",position:"relative",paddingTop:20}}>

            {selected.__allowEdit &&(
                <div style={{position:"absolute",top:0,right:0,paddingTop:5,paddingRight:5}}>
                    <MobEditButtonIcon onClick={()=> modalEditTels.current.show(selected)}/>
                </div>
            )}


            {tels.map((item,index)=>{
                return(
                    <div key={item.id}>
                        {index > 0 && (
                            <Divider/>
                        )}
                        <div style={{display: "flex", flexDirection: "column", padding: "5px 10px"}}>
                            <span style={{
                                color: "#000",
                                fontSize: 13,
                                marginBottom: 5,
                                fontWeight: item.main ? "bold" : "400"
                            }}>{item.title}</span>

                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span style={{color: MOBCOLORS.blue.color, fontSize: 15}}
                                      onClick={() => window.open("tel:" + item.number)}>{item.formatedNumber}</span>

                                <div style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    gap: 10
                                }}>

                                    <div style={{padding: 5}} onClick={() => window.open("tel:" + item.number)}>
                                        <DynamicIcon name={"phone"} fill={MOBCOLORS.green.color} strokeWidth={0} size={20} style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}/>
                                    </div>

                                    <div style={{padding: 5}} onClick={() => window.open("https://wa.me/" + item.number)}>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "100%",
                                            padding: 8,
                                            backgroundColor: MOBCOLORS.green.color
                                        }}
                                        >
                                            <img src={"/img/brands/whatsapp-white.png"} style={{width:20,height:20}}/>
                                        </div>
                                    </div>

                                    <div style={{padding: 5}} onClick={() => window.open("sms:" + item.number)}>
                                        <DynamicIcon name={"message-circle"} fill={MOBCOLORS.cyan.color} strokeWidth={0} size={20}
                                                     style={{
                                                         display: "flex",
                                                         justifyContent: "center",
                                                         alignItems: "center"
                                                     }}/>
                                    </div>

                                    <Popover
                                        content={(<Trans>Tel. Copié</Trans>)}
                                        trigger='click'
                                        placement='top'
                                        mode='dark'
                                    >
                                        <div style={{display: "flex", alignItems: "center", gap: 5}}
                                             onClick={() => {
                                                 contactCopie(item.number)
                                             }}>
                                            <DynamicIcon name={"copy"} color={"#000"} size={20} style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}/>
                                        </div>
                                    </Popover>

                                </div>
                            </div>
                        </div>
                    </div>

                )
            })}
        </MobCard>
            <ModalEditTels getRef={(ref)=>modalEditTels.current=ref} onFinish={()=>selected.__refreshData()}/>
        </>
    )
}


function CardEmails({selected}) {
    const emails=getContactEmails(selected)

    const modalEditEmails=useRef(null);

    if(emails.length===0 || selected?.parents?.length>0){
        return null
    }

    return(
        <>
            <MobCard style={{boxShadow:"none",position:"relative",paddingTop:20}}>

                {selected.__allowEdit &&(
                    <div style={{position:"absolute",top:0,right:0,paddingTop:5,paddingRight:5}}>
                        <MobEditButtonIcon onClick={()=> modalEditEmails.current.show(selected)}/>
                    </div>
                )}

                {emails.map((item,index)=>{
                    return(
                        <div key={item.id}>
                            {index>0 &&(
                                <Divider/>
                            )}
                            <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>
                                <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:item.main?"bold":"400"}}>{item.title}</span>

                                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                    <span style={{color:MOBCOLORS.blue.color,fontSize:15}} onClick={()=>window.open("mailto:"+item.email)}>{item.email}</span>

                                    <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10}}>

                                        <div style={{padding:5}} onClick={()=>window.open("mailto:"+item.email)}>
                                            <DynamicIcon name={"mail"} color={MOBCOLORS.gray.color} size={20} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
                                        </div>


                                        <Popover
                                            content={(<Trans>Email Copié</Trans>)}
                                            trigger='click'
                                            placement='top'
                                            mode='dark'
                                        >
                                            <div style={{display: "flex", alignItems: "center", gap: 5}}
                                                 onClick={() => {contactCopie(item.email)}}>
                                                <DynamicIcon name={"copy"} color={"#000"} size={20} style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                                            </div>
                                        </Popover>

                                    </div>
                                </div>
                            </div>
                        </div>

                    )
                })}
            </MobCard>

            <ModalEditEmails getRef={(ref)=>modalEditEmails.current=ref} onFinish={()=>selected.__refreshData()}/>
        </>
    )
}

function CardAdresses({selected}) {
    const adresses=getContactAdresses(selected)

    const modalEditAdresses=useRef(null);
    const actionSheetManager=useActionSheet()

    const openNav=(adresseId)=>{
        const adresse=adresses.find(i=>i.id===adresseId);

        actionSheetManager.open([
            {text:"Google Maps" ,onClick:()=>window.open("https://www.google.com/maps/search/?api=1&query="+encodeURIComponent(adresse.fullAdresse),"_blank")},
            {text:"Waze",onClick:()=>window.open("https://waze.com/ul?navigate=yes&q="+encodeURIComponent(adresse.fullAdresse),"_blank")},
            {text:"Apple Maps",onClick:()=>window.open("https://maps.apple.com/?address="+encodeURIComponent(adresse.fullAdresse),"_blank")},
        ],(<Trans>Ouvrir dans :</Trans>))
    }

    if(adresses.length===0 || selected?.parents?.length>0){
        return null
    }

    return(
        <>
            <MobCard style={{boxShadow:"none",position:"relative",paddingTop:20}}>

                {selected.__allowEdit &&(
                    <div style={{position:"absolute",top:0,right:0,paddingTop:5,paddingRight:5}}>
                        <MobEditButtonIcon onClick={()=> modalEditAdresses.current.show(selected)}/>
                    </div>
                )}

                {adresses.map((item,index)=>{
                    return(
                        <div key={item.id}>
                            {index > 0 && (
                                <Divider/>
                            )}
                            <div style={{display: "flex", flexDirection: "column", padding: "5px 10px"}}>
                                <span style={{
                                    color: "#000",
                                    fontSize: 13,
                                    marginBottom: 5,
                                    fontWeight: item.main ? "bold" : "400"
                                }}>{item.nom} {item.siren && ("(" + item.siren + ")")}</span>

                                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        color: MOBCOLORS.blue.color,
                                        fontSize: 15
                                    }} onClick={() => openNav(item.id)}>
                                        <span>{item.adresse}</span>
                                        <span>{item.postal} {item.ville}</span>
                                        <span>{item.pays}</span>
                                    </div>

                                    <div style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: 10
                                    }}>

                                        <div style={{padding: 5}} onClick={() => openNav(item.id)}>
                                            <DynamicIcon name={"map-pin"} color={"#000"} size={20} style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}/>
                                        </div>

                                        <Popover
                                            content={(<Trans>Adresse Copié</Trans>)}
                                            trigger='click'
                                            placement='top'
                                            mode='dark'
                                        >
                                            <div style={{display: "flex", alignItems: "center", gap: 5}}
                                                 onClick={() => {
                                                     contactCopie(item.fullAdresse)
                                                 }}>
                                                <DynamicIcon name={"copy"} color={"#000"} size={20} style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}/>
                                            </div>
                                        </Popover>

                                    </div>
                                </div>
                            </div>
                        </div>

                    )
                })}
            </MobCard>

            <ModalEditAdresses getRef={(ref)=>modalEditAdresses.current=ref} onFinish={()=>selected.__refreshData()}/>
        </>
    )
}


function CardDDN({selected}) {

    const modalAnniv=useRef(null)

    if(!selected.ddn){
        return null
    }

    const hasRappel=selected?.rappelAnniv?.silence===false || false

    const getAge=(date)=>{
        var today = new Date();
        var birthDate = new Date(date);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    const getAgeHeb = (ddn, todayDate = new Date()) => {
        const todayHDate = new HDate(todayDate);
        const birthHDate = getHebddn(ddn, true); // renvoie une HDate
        let age = todayHDate.getFullYear() - birthHDate.getFullYear();

        // Crée l'anniversaire hébraïque de cette année (en HDate)
        const birthdayThisYear = new HDate(birthHDate.getDate(), birthHDate.getMonth(), todayHDate.getFullYear());

        // Compare les équivalents grégoriens
        if (todayDate.getTime() < birthdayThisYear.greg().getTime()) {
            age--;
        }

        return age;
    };



    const getHebddn=(ddn,getHDate=false)=>{
        let org = null
        try {
            org = JSON.parse(localStorage.getItem("ORG"))
        } catch (e) {
        }

        var hdate = new HDate(new Date(ddn))
        if (org) {
            const hebcal = new Hebcal(org, new Date(), org.lat, org.long)
            hdate = hebcal.getAnnivHDate(new Date(ddn))
        }
        if(getHDate){
            return hdate
        }
        return hdate.getDate() + " " + hdate.getMonthName() + " " + hdate.getFullYear()
    }

    return(
        <Fragment>
            <MobCard style={{boxShadow:"none"}}>
                <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>
                    <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:"400"}}><Trans>Date de naissance</Trans></span>

                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{color:MOBCOLORS.blue.color,fontSize:15}}  onClick={()=>modalAnniv.current.show(selected.id,selected?.rappelAnniv)}>{moment(selected.ddn).format("DD/MM/YYYY")}  - {getAge(new Date(selected.ddn))} <Trans>an(s)</Trans></span>

                        <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10}}>

                            <div style={{padding:5}} onClick={()=>modalAnniv.current.show(selected.id,selected?.rappelAnniv)}>
                                <DynamicIcon name={"bell"} fill={hasRappel?MOBCOLORS.blue.color:"transparent"} color={hasRappel?MOBCOLORS.blue.color:MOBCOLORS.gray.color} size={24} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>
                    <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:"400"}}><Trans>Date de naissance hébraïque</Trans></span>

                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{color:MOBCOLORS.blue.color,fontSize:15}}  onClick={()=>modalAnniv.current.show(selected.id,selected?.rappelAnniv)}>{getHebddn(selected.ddn)} - {getAgeHeb(selected.ddn)} <Trans>an(s)</Trans></span>

                        <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10}}>

                            <div style={{padding:5}} onClick={()=>modalAnniv.current.show(selected.id,selected?.rappelAnniv)}>
                                <DynamicIcon name={"bell"} fill={hasRappel?MOBCOLORS.blue.color:"transparent"} color={hasRappel?MOBCOLORS.blue.color:MOBCOLORS.gray.color} size={24} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
                            </div>
                        </div>
                    </div>
                </div>
            </MobCard>

            <ModalAnniv getRef={ref => modalAnniv.current = ref} onFinish={() => selected.__refreshData()}/>
        </Fragment>
    )
}


export function CardNote({selected}) {

    const [description, setDescription] = useState(selected.description)
    const inputRef = useRef();

    const updateData=async ()=>{
        console.log("CardNote updateData")
        await ApiService.post("/contact/edit/partial/"+selected.id, {description:description})
        selected.__refreshData()
    }


    const autoResize = () => {
        const el = inputRef.current;
        if (el) {
            el.style.height = "auto"; // reset
            el.style.height = el.scrollHeight + "px"; // ajustement
        }
    };

    useEffect(() => {
        autoResize(); // initial resize au mount
    }, []);

    useEffect(() => {
        autoResize(); // resize à chaque update de contenu
    }, [description]);

    return(
        <Fragment>
            <MobCard style={{boxShadow:"none"}}>
                <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>
                    <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:"600"}}><Trans>Notes :</Trans></span>

                    <div style={{minHeight:100,border:"1px solid #CCC",borderRadius:10,padding:5}}>
                        <textarea
                            ref={inputRef}
                            value={description}
                            onChange={(e)=>setDescription(e.target.value)}
                            placeholder={t`Ecrivez ici vos notes`}
                            style={{
                                height:"100%",
                                width:"100%",
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                fontSize: 16,
                                flex: 1,
                                color: "#333",
                                overflow: "hidden",
                                resize: "none",
                                boxSizing: "border-box",
                            }}
                            onBlur={() => {
                                updateData()
                            }}
                        />
                    </div>
                </div>
            </MobCard>
        </Fragment>
    )
}


function Divider(){
    return(
        <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
            <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
        </div>
    )
}
